import { t } from 'i18next';
import { I18N_RESTRICTED_SESSION_ALERT_BAR } from '../constants';

export type RestrictedSessionAlertBarProps = {
  show: boolean;
  platformName: string;
};

export function RestrictedSessionAlertBar({ show, platformName }: RestrictedSessionAlertBarProps) {
  if (!show) return null;

  return (
    <div className="relative isolate z-20 flex flex-wrap items-center justify-center gap-1 overflow-hidden bg-spark-info-soft px-6 py-2.5 text-center text-[13px] text-spark-info-soft-text leading-4.5 sm:px-3.5">
      <span className="hidden items-center justify-center rounded-full bg-linear-to-r from-indigo-500 via-purple-500 to-pink-500 px-2.5 py-1 text-white text-xs transition-all lg:inline-flex">
        {t(`${I18N_RESTRICTED_SESSION_ALERT_BAR}.logged_in_via`, { platformName })}
      </span>
      <span>{t(`${I18N_RESTRICTED_SESSION_ALERT_BAR}.message`)}</span>
      <a href="/logout" className="font-semibold text-spark-primary-accent">
        {t(`${I18N_RESTRICTED_SESSION_ALERT_BAR}.log_out`)}
      </a>
    </div>
  );
}
